import Header from '../../../../googleAd/shared/sections/Header'
import Annotation from '../../../../googleAd/shared/sections/FirstView/Annotation'
import VerticalEntryForm from '../../../shared/forms/VerticalEntryForm'
import instagramConfig from './config'
import { StepProvider } from '@/components/Context/StepContext'
import styles from './InstagramAllRegionFormPage.module.css'
import { AllRegionSpLandingPageProps } from './types'
import { useAbTestGtm, useAbTestPattern } from '@/components/utils/abTest'
import { SlimFirstView } from '@/components/Common/SlimFirstView'
import { CafeFirstView } from '@/components/Common/CafeFirstView'
import { CompanyLogoStrip } from '@/components/Common/CompanyLogoStrip'

const InstagramAllRegionFormPage: React.FC<AllRegionSpLandingPageProps> = ({ prefectures }) => {
    const { dataViewLabel } = useAbTestGtm()
    const { isC, isD } = useAbTestPattern()

    return(
        <div className={styles.InstagramAllRegionFormPageWrap}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header id='renewal_top' dataViewLabel={dataViewLabel('HD')} />
                {/* DEV-3390: Aパターンが無いconfigなので、未解決（初回レンダー）・テスト対象外・
                    対照群のBはすべてこの既定枝。isB で囲むと初回レンダー（必ず
                    DEFAULT_PATTERN='A'）でFVが消えてしまう。配分と中身は settings.ts を参照 */}
                {!isC && !isD && (
                    <SlimFirstView
                        // 判定確定でラベルが CT_FirstView → CT_FirstView_3390_B に変わるとき、
                        // keyを変えて要素ごと作り直す。GTMの要素表示トリガーは「1要素につき1度」で、
                        // 属性の書き換えだけだと素ラベルで発火済み扱いになり対照群の表示数が落ちる。
                        // C/Dは要素自体が差し替わるので元から問題にならない。
                        key={dataViewLabel('CT_FirstView')}
                        dataViewLabel={dataViewLabel('CT_FirstView')}
                    />
                )}
                {isC && <CafeFirstView variant='hero' dataViewLabel={dataViewLabel('CT_FirstView')} />}
                {isD && <CafeFirstView variant='short' dataViewLabel={dataViewLabel('CT_FirstView')} />}
                <CompanyLogoStrip />
                <div className={styles.formWrap}>
                    <VerticalEntryForm
                        prefectures={prefectures}
                        config={instagramConfig}
                    />
                    {/* DEV-3366→DEV-3419: 帯画像には「求人数No.1※」が入るが、旧FV画像内にあった
                        調査注記は消えるため、googleAdと同じ内容の注記をここで補う
                        （DEV-3102/DEV-3239でFV差し替え時に注記を足したのと同じ扱い） */}
                    <Annotation />
                </div>
            </StepProvider>
        </div>
    )
}

export default InstagramAllRegionFormPage
